import appTemplate from '../layouts/app.html';
import HomeFeedService from '../components/home/home-feed.service';
import UnauthenticatedAssetsService from '../components/services/unauthenticated-assets.service';
import CommunityManagersService from '../components/services/community-managers.service';
import community from '../components/community/community.component';
import home from '../components/home/home.component';
import resources from '../components/resource/resources.component';
import { SingleResourceComponent } from '../ng-app/article/single-resource/single-resource.component';
import UserResolver from '../authentication/user-resolver';
import UserAuthenticator from '../authentication/user-authenticator';
import FeatureToggleResolver from '../feature-toggles/feature-toggle-resolver';

const HomeRouter = {
  route: (module) => {
    module
      .service('HomeFeedService', HomeFeedService)
      .service('UnauthenticatedAssetsService', UnauthenticatedAssetsService)
      .service('CommunityManagersService', CommunityManagersService)
      .component('home', home)
      .component('community', community)
      .component('resources', resources)
      .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
          .state('root', {
            controller: ['$state', '$scope', '$rootScope', '$timeout', '$window', 'featureFlags', 'user', 'ConfigService', function ($state, $scope, $rootScope, $timeout, $window, featureFlags, user, ConfigService) {
              $scope.$state = $state;
              $scope.featureFlags = featureFlags;
              // Restyles the skip link in the 2026 design.
              $scope.designRefresh = featureFlags.isOn('UTEST_DESIGN_REFRESH_2026');
              $rootScope.userIdentityVerification = featureFlags.isOn('USER_IDENTITY_VERIFICATION');
              ConfigService.config().then((res) => {
                $rootScope.personaVerificationUrl = featureFlags.isOn('TESTER_PROFILE_UX_2026')
                  ? `${res.data.profile_url}/tester-profile/identity`
                  : `${res.data.profile_url}/account/my-profile/identity`;
              });
              if (user) {
                $scope.currentUser = user;
                $rootScope.showAuthenticatedUtest = true;
                $rootScope.scrollBehaviorClass = 'overflow-hidden';
                $timeout(() => $rootScope.$broadcast('adjust-nav-padding'));
              } else {
                $rootScope.showAuthenticatedUtest = false;
                $rootScope.scrollBehaviorClass = 'overflow-scroll';
              }

              $scope.skipToMainContent = () => {
                const mainContent = document.getElementById('main-content-container');
                if (mainContent) {
                  mainContent.setAttribute('tabindex', '-1');
                  mainContent.focus();
                }
              };

              $scope.handleSkipKeydown = (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  $scope.skipToMainContent();
                }
              };
            }],
            url: '',
            abstract: true,
            template: appTemplate,
            resolve: {
              features: FeatureToggleResolver,
              user: UserResolver,
            },
          })
          .state('home', {
            url: '/',
            parent: 'root',
            component: 'home',
            resolve: {
              user: UserResolver,
              title: [() => 'uTest - The Professional Network for Testers'],
              staticPage: ['StaticPageService', function (StaticPageService) {
                return StaticPageService.get('home-5tat1c').then((response) => {
                  if (response.data) {
                    return response.data;
                  }
                }).catch(() => false);
              }],
            },
          })
          // FLO-54052 (2026-10-19): the same homepage at /home. On the tester-app host "/" belongs to
          // tester-app (its dashboard), so uTest's homepage needs its own path there; index.ts redirects
          // in-app `home` transitions here on that host. On www both "/" and "/home" render it.
          .state('homeApp', {
            url: '/home',
            parent: 'root',
            component: 'home',
            resolve: {
              user: UserResolver,
              title: [() => 'uTest - The Professional Network for Testers'],
              staticPage: ['StaticPageService', function (StaticPageService) {
                return StaticPageService.get('home-5tat1c').then((response) => {
                  if (response.data) {
                    return response.data;
                  }
                }).catch(() => false);
              }],
            },
          })
          .state('community', {
            url: '/community',
            parent: 'root',
            template: `
              <ut-community-page ng-if="$resolve.useAngularCommunity" [user]="$resolve.user"></ut-community-page>
              <community ng-if="!$resolve.useAngularCommunity" user="$resolve.user"></community>
            `,
            resolve: {
              user: UserAuthenticator,
              title: [() => 'uTest Community Feed'],
              useAngularCommunity: ['features', 'featureFlags', function (features, featureFlags) {
                return featureFlags.isOn('UTEST_DESIGN_REFRESH_2026');
              }],
            },
          })
          .state('resources', {
            url: '/resources',
            parent: 'root',
            component: 'resources',
            resolve: {
              staticPage: ['StaticPageService', 'featureFlags', '$state', function (StaticPageService, featureFlags, $state) {
                return StaticPageService.get('resources-5tat1c').then((response) => {
                  if (response.data) {
                    return response.data;
                  }
                }).catch(() => $state.go('fourohfour', null, { location: false }));
              }],
              title: [() => 'uTest Resources'],
            },
          })
          .state('singleresource', {
            parent: 'root',
            url: '/resources/:articleId',
            component: SingleResourceComponent,
            resolve: {
              article: ['ArticleService', '$transition$', function (ArticleService, $transition$) {
                return ArticleService.find($transition$.params().articleId).then(res => res.data);
              }],
              title: ['article', article => `uTest Resources - ${article.title}`],
            },
          });
      }]);
  },
};

export default HomeRouter;
